// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  width: 100%;
}
@media (min-width: 640px) {
  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {
  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {
  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {
  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {
  .container {
    max-width: 1536px;
  }
}
.collapse {
  visibility: collapse;
}
.fixed {
  position: fixed;
}
.sticky {
  position: sticky;
}
.m-auto {
  margin: auto;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-\\[50px\\] {
  margin-bottom: 50px;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mt-8 {
  margin-top: 2rem;
}
.flex {
  display: flex;
}
.\\!table {
  display: table !important;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.h-5 {
  height: 1.25rem;
}
.w-10 {
  width: 2.5rem;
}
.w-16 {
  width: 4rem;
}
.w-5 {
  width: 1.25rem;
}
.w-full {
  width: 100%;
}
.min-w-\\[36px\\] {
  min-width: 36px;
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.cursor-pointer {
  cursor: pointer;
}
.select-none {
  -webkit-user-select: none;
          user-select: none;
}
.flex-col {
  flex-direction: column;
}
.items-center {
  align-items: center;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-2 {
  gap: 0.5rem;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-\\[20px\\] {
  border-radius: 20px;
}
.border {
  border-width: 1px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}
.bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
.p-1 {
  padding: 0.25rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.py-24 {
  padding-top: 6rem;
  padding-bottom: 6rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.pb-\\[18px\\] {
  padding-bottom: 18px;
}
.pl-2 {
  padding-left: 0.5rem;
}
.pr-2 {
  padding-right: 0.5rem;
}
.pt-\\[14px\\] {
  padding-top: 14px;
}
.text-left {
  text-align: left;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-medium {
  font-weight: 500;
}
.uppercase {
  text-transform: uppercase;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[5px_10px_10px\\] {
  --tw-shadow: 5px 10px 10px;
  --tw-shadow-colored: 5px 10px 10px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline {
  outline-style: solid;
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

html,
body {
  margin: 0px;
}

#App {
  height: 100vh;
  font-family: sans-serif;
}

.bm-item {
  margin-bottom: 0.625rem;
  display: inline-block;
  --tw-text-opacity: 1;
  color: rgb(209 209 209 / var(--tw-text-opacity, 1));
  text-decoration-line: none;
  transition-property: color;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
  transition-duration: 0.2s;
}

.bm-item:hover {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.bm-burger-button {
  position: fixed;
  right: 2.25rem;
  top: 2.25rem;
  height: 30px;
  width: 2.25rem;
}

/* Color/shape of burger icon bars */
.bm-burger-bars {
  background: #373a47;
}

/* Position and sizing of clickable cross button */
.bm-cross-button {
  height: 1.5rem;
  width: 1.5rem;
}

/* Color/shape of close button cross */
.bm-cross {
  background: #bdc3c7;
}

/* General Sidebar styles */
.bm-menu {
  padding-left: 1.5em;
  padding-right: 1.5em;
  padding-top: 2.5em;
  padding-bottom: 0px;
  font-size: 1.15em;
  background: #000;
}

/* .bm-menu-wrap {
  @apply fixed z-[1100] w-[30vw] h-full transition-all duration-[0.5s] ease-[ease] delay-[0s] right-[inherit];
} */

/* Morph shape necessary with bubble or elastic */
.bm-morph-shape {
  fill: #373a47;
}

/* Wrapper for item list */
.bm-item-list {
  --tw-text-opacity: 1;
  color: rgb(184 183 173 / var(--tw-text-opacity, 1));
}

/* Styling of overlay */
.bm-overlay {
  background: rgba(0, 0, 0, 0.3);
}

table {
  border-radius: 20px;
  --tw-shadow: 5px 10px 10px;
  --tw-shadow-colored: 5px 10px 10px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  -moz-border-radius: 10px;
  -webkit-border-radius: 10px;
}

table tr:last-child td:first-child {
  border-bottom-left-radius: 10px;
}

table tr:last-child td:last-child {
  border-bottom-right-radius: 10px;
}

.custom_button {
  margin-left: -5px;
  margin-top: 0.625rem;
  width: 5rem;
  cursor: pointer;
  border-radius: 5px;
  border-width: 0px;
  padding-left: 0px;
  padding-right: 0px;
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
  font-size: 1rem;
  line-height: 1.5rem;
  text-transform: uppercase;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

/* INPUTS */

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

/* LOADER PAGE */
.progress-loader {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
  width: 150px;
  background: rgba(175, 175, 175, 0.253);
  height: 3px;
  border-radius: 7px;
}

.progress {
  content: "";
  width: 1px;
  height: 3px;
  border-radius: 7px;
  transition: 0.5s;
  animation: loading1274 2s ease infinite;
}

@keyframes loading1274 {
  0% {
    width: 0%;
  }

  10% {
    width: 10%;
  }

  50% {
    width: 40%;
  }

  60% {
    width: 60%;
  }

  100% {
    width: 100%;
  }
}

/* SWITCH */
.custom_checkbox {
  display: none;
}

.switch {
  position: relative;
  width: fit-content;
  padding: 10px 20px;
  background-color: rgb(46, 46, 46);
  border-radius: 50px;
  z-index: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: white;
  font-size: 0.9em;
  font-weight: 600;
  transition: all 0.3s;
}
.switch svg path {
  fill: white;
}
.custom_checkbox:checked + .switch {
  background-color: rgb(51, 150, 24);
  box-shadow: 0px 0px 40px rgb(51, 150, 24);
}


/* SELECTOR */
.customCheckBoxHolder {
  margin: 5px;
  display: flex;
}

.customCheckBox {
  width: fit-content;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  padding: 2px 8px;
  background-color: rgba(0, 0, 0, 0.16);
  border-radius: 0px;
  color: rgba(255, 255, 255, 0.7);
  transition-timing-function: cubic-bezier(0.25, 0.8, 0.25, 1);
  transition-duration: 300ms;
  transition-property: color, background-color, box-shadow;
  display: flex;
  height: 32px;
  align-items: center;
  box-shadow: rgba(0, 0, 0, 0.15) 0px 2px 1px 0px inset, rgba(255, 255, 255, 0.17) 0px 1px 1px 0px;
  outline: none;
  justify-content: center;
  min-width: 55px;
}

.customCheckBox:hover {
  background-color: #2c2c2c;
  color: white;
  box-shadow: rgba(0, 0, 0, 0.23) 0px -4px 1px 0px inset, rgba(255, 255, 255, 0.17) 0px -1px 1px 0px, rgba(0, 0, 0, 0.17) 0px 2px 4px 1px;
}

.customCheckBox .inner {
  font-size: 18px;
  font-weight: 900;
  pointer-events: none;
  transition-timing-function: cubic-bezier(0.25, 0.8, 0.25, 1);
  transition-duration: 300ms;
  transition-property: transform;
  transform: translateY(0px);
}

.customCheckBox:hover .inner {
  transform: translateY(-2px);
}

.customCheckBoxWrapper:first-of-type .customCheckBox {
  border-radius: 5px;
}

.customCheckBoxWrapper:last-of-type .customCheckBox {
  border-radius: 5px;
}

.customCheckBoxInput {
  display: none;
}
.customCheckBoxInputSell {
  display: none;
}

.customCheckBoxInput:checked + .customCheckBoxWrapper .customCheckBox {
  background-color: #2d6737;
  color: white;
  box-shadow: rgba(0, 0, 0, 0.23) 0px -4px 1px 0px inset, rgba(255, 255, 255, 0.17) 0px -1px 1px 0px, rgba(0, 0, 0, 0.17) 0px 2px 4px 1px;
}

.customCheckBoxInput:checked + .customCheckBoxWrapper .customCheckBox .inner {
  transform: translateY(-2px);
}

.customCheckBoxInput + .customCheckBoxWrapper .customCheckBox:hover {
  background-color: #2d6737;
  box-shadow: rgba(0, 0, 0, 0.26) 0px -4px 1px 0px inset, rgba(255, 255, 255, 0.17) 0px -1px 1px 0px, rgba(0, 0, 0, 0.15) 0px 3px 6px 2px;
}

.customCheckBoxInputSell:checked + .customCheckBoxWrapper .customCheckBox {
  background-color: #7e0c0c;
  color: white;
  box-shadow: rgba(0, 0, 0, 0.23) 0px -4px 1px 0px inset, rgba(255, 255, 255, 0.17) 0px -1px 1px 0px, rgba(0, 0, 0, 0.17) 0px 2px 4px 1px;
}

.customCheckBoxInputSell:checked + .customCheckBoxWrapper .customCheckBox .inner {
  transform: translateY(-2px);
}

.customCheckBoxInputSell + .customCheckBoxWrapper .customCheckBox:hover {
  background-color: #7e0c0c;
  box-shadow: rgba(0, 0, 0, 0.26) 0px -4px 1px 0px inset, rgba(255, 255, 255, 0.17) 0px -1px 1px 0px, rgba(0, 0, 0, 0.15) 0px 3px 6px 2px;
}

.customCheckBoxWrapper .customCheckBox:hover .inner {
  transform: translateY(-2px);
}


/* SELECTOR */


@media (min-width: 640px) {
  .sm\\:mb-0 {
    margin-bottom: 0px;
  }
  .sm\\:mr-auto {
    margin-right: auto;
  }
  .sm\\:flex-row {
    flex-direction: row;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EAAA;AAAoB;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AACpB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB,yDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;;AAIjB;;EAAA;AAAU;;AAIV;EAAA,aAAe;EACf;AADe;;AAKf;EAAA,uBAA4G;EAA5G,qBAA4G;EAA5G,oBAA4G;EAA5G,mDAA4G;EAA5G,0BAA4G;EAA5G,0BAA4G;EAA5G,wDAA4G;EAA5G,0BAA4G;EAA5G;AAA4G;;AAA5G;EAAA,oBAA4G;EAA5G;AAA4G;;AAI5G;EAAA,eAAuC;EAAvC,cAAuC;EAAvC,YAAuC;EAAvC,YAAuC;EAAvC;AAAuC;;AAGzC,oCAAoC;AACpC;EACE,mBAAmB;AACrB;;AAEA,kDAAkD;AAEhD;EAAA,cAAc;EAAd;AAAc;;AAGhB,sCAAsC;AACtC;EACE,mBAAmB;AACrB;;AAEA,2BAA2B;AAEzB;EAAA,mBAA+C;EAA/C,oBAA+C;EAA/C,kBAA+C;EAA/C,mBAA+C;EAA/C,iBAA+C;EAC/C;AAD+C;;AAIjD;;GAEG;;AAEH,iDAAiD;AAE/C;EAAA;AAAqB;;AAGvB,0BAA0B;AAExB;EAAA,oBAAqB;EAArB;AAAqB;;AAGvB,uBAAuB;AACvB;EACE,8BAA8B;AAChC;;AAGE;EAAA,mBAA4C;EAA5C,0BAA4C;EAA5C,yDAA4C;EAA5C,uGAA4C;EAC5C,wBAAwB;EACxB;AAF4C;;AAM5C;EAAA;AAAwB;;AAIxB;EAAA;AAAwB;;AAIxB;EAAA,iBAA6G;EAA7G,oBAA6G;EAA7G,WAA6G;EAA7G,eAA6G;EAA7G,kBAA6G;EAA7G,iBAA6G;EAA7G,iBAA6G;EAA7G,kBAA6G;EAA7G,qBAA6G;EAA7G,wBAA6G;EAA7G,eAA6G;EAA7G,mBAA6G;EAA7G,yBAA6G;EAA7G,oBAA6G;EAA7G;AAA6G;;AAG/G,WAAW;;AAEX;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,0BAA0B;AAC5B;;AAEA,gBAAgB;AAChB;EACE,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAIhC,YAAY;EACZ,sCAAsC;EACtC,WAAW;EACX,kBAAkB;AANpB;;AASA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,WAAW;AACX;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,iCAAiC;EACjC,mBAAmB;EACnB,UAAU;EACV,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,WAAW;AACb;AACA;EACE,kCAAkC;EAClC,yCAAyC;AAC3C;;;AAGA,aAAa;AACb;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,+BAA+B;EAC/B,4DAA4D;EAC5D,0BAA0B;EAC1B,wDAAwD;EACxD,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,gGAAgG;EAChG,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,uIAAuI;AACzI;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,4DAA4D;EAC5D,0BAA0B;EAC1B,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,uIAAuI;AACzI;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,uIAAuI;AACzI;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,uIAAuI;AACzI;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,uIAAuI;AACzI;;AAEA;EACE,2BAA2B;AAC7B;;;AAGA,aAAa;;;AA3Qb;EAAA;IAAA;EA4QA;EA5QA;IAAA;EA4QA;EA5QA;IAAA;EA4QA;AAAA","sourcesContent":["@tailwind components;\n@tailwind utilities;\n\nhtml,\nbody {\n  @apply m-0;\n}\n\n#App {\n  @apply h-screen;\n  font-family: sans-serif;\n}\n\n.bm-item {\n  @apply inline-block no-underline text-[#d1d1d1] transition-[color] duration-[0.2s] mb-2.5 hover:text-[white];\n}\n\n.bm-burger-button {\n  @apply fixed w-9 h-[30px] right-9 top-9;\n}\n\n/* Color/shape of burger icon bars */\n.bm-burger-bars {\n  background: #373a47;\n}\n\n/* Position and sizing of clickable cross button */\n.bm-cross-button {\n  @apply h-6 w-6;\n}\n\n/* Color/shape of close button cross */\n.bm-cross {\n  background: #bdc3c7;\n}\n\n/* General Sidebar styles */\n.bm-menu {\n  @apply text-[1.15em] pt-[2.5em] pb-0 px-[1.5em];\n  background: #000;\n}\n\n/* .bm-menu-wrap {\n  @apply fixed z-[1100] w-[30vw] h-full transition-all duration-[0.5s] ease-[ease] delay-[0s] right-[inherit];\n} */\n\n/* Morph shape necessary with bubble or elastic */\n.bm-morph-shape {\n  @apply fill-[#373a47];\n}\n\n/* Wrapper for item list */\n.bm-item-list {\n  @apply text-[#b8b7ad];\n}\n\n/* Styling of overlay */\n.bm-overlay {\n  background: rgba(0, 0, 0, 0.3);\n}\n\ntable {\n  @apply rounded-[20px] shadow-[5px_10px_10px];\n  -moz-border-radius: 10px;\n  -webkit-border-radius: 10px;\n}\n\ntable tr:last-child td:first-child {\n  @apply rounded-bl-[10px];\n}\n\ntable tr:last-child td:last-child {\n  @apply rounded-br-[10px];\n}\n\n.custom_button {\n  @apply cursor-pointer text-white text-base uppercase w-20 ml-[-5px] mt-2.5 px-0 py-2.5 rounded-[5px] border-0;\n}\n\n/* INPUTS */\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=number] {\n  -moz-appearance: textfield;\n}\n\n/* LOADER PAGE */\n.progress-loader {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.progress-loader {\n  width: 150px;\n  background: rgba(175, 175, 175, 0.253);\n  height: 3px;\n  border-radius: 7px;\n}\n\n.progress {\n  content: \"\";\n  width: 1px;\n  height: 3px;\n  border-radius: 7px;\n  transition: 0.5s;\n  animation: loading1274 2s ease infinite;\n}\n\n@keyframes loading1274 {\n  0% {\n    width: 0%;\n  }\n\n  10% {\n    width: 10%;\n  }\n\n  50% {\n    width: 40%;\n  }\n\n  60% {\n    width: 60%;\n  }\n\n  100% {\n    width: 100%;\n  }\n}\n\n/* SWITCH */\n.custom_checkbox {\n  display: none;\n}\n\n.switch {\n  position: relative;\n  width: fit-content;\n  padding: 10px 20px;\n  background-color: rgb(46, 46, 46);\n  border-radius: 50px;\n  z-index: 1;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  color: white;\n  font-size: 0.9em;\n  font-weight: 600;\n  transition: all 0.3s;\n}\n.switch svg path {\n  fill: white;\n}\n.custom_checkbox:checked + .switch {\n  background-color: rgb(51, 150, 24);\n  box-shadow: 0px 0px 40px rgb(51, 150, 24);\n}\n\n\n/* SELECTOR */\n.customCheckBoxHolder {\n  margin: 5px;\n  display: flex;\n}\n\n.customCheckBox {\n  width: fit-content;\n  position: relative;\n  overflow: hidden;\n  cursor: pointer;\n  user-select: none;\n  padding: 2px 8px;\n  background-color: rgba(0, 0, 0, 0.16);\n  border-radius: 0px;\n  color: rgba(255, 255, 255, 0.7);\n  transition-timing-function: cubic-bezier(0.25, 0.8, 0.25, 1);\n  transition-duration: 300ms;\n  transition-property: color, background-color, box-shadow;\n  display: flex;\n  height: 32px;\n  align-items: center;\n  box-shadow: rgba(0, 0, 0, 0.15) 0px 2px 1px 0px inset, rgba(255, 255, 255, 0.17) 0px 1px 1px 0px;\n  outline: none;\n  justify-content: center;\n  min-width: 55px;\n}\n\n.customCheckBox:hover {\n  background-color: #2c2c2c;\n  color: white;\n  box-shadow: rgba(0, 0, 0, 0.23) 0px -4px 1px 0px inset, rgba(255, 255, 255, 0.17) 0px -1px 1px 0px, rgba(0, 0, 0, 0.17) 0px 2px 4px 1px;\n}\n\n.customCheckBox .inner {\n  font-size: 18px;\n  font-weight: 900;\n  pointer-events: none;\n  transition-timing-function: cubic-bezier(0.25, 0.8, 0.25, 1);\n  transition-duration: 300ms;\n  transition-property: transform;\n  transform: translateY(0px);\n}\n\n.customCheckBox:hover .inner {\n  transform: translateY(-2px);\n}\n\n.customCheckBoxWrapper:first-of-type .customCheckBox {\n  border-radius: 5px;\n}\n\n.customCheckBoxWrapper:last-of-type .customCheckBox {\n  border-radius: 5px;\n}\n\n.customCheckBoxInput {\n  display: none;\n}\n.customCheckBoxInputSell {\n  display: none;\n}\n\n.customCheckBoxInput:checked + .customCheckBoxWrapper .customCheckBox {\n  background-color: #2d6737;\n  color: white;\n  box-shadow: rgba(0, 0, 0, 0.23) 0px -4px 1px 0px inset, rgba(255, 255, 255, 0.17) 0px -1px 1px 0px, rgba(0, 0, 0, 0.17) 0px 2px 4px 1px;\n}\n\n.customCheckBoxInput:checked + .customCheckBoxWrapper .customCheckBox .inner {\n  transform: translateY(-2px);\n}\n\n.customCheckBoxInput + .customCheckBoxWrapper .customCheckBox:hover {\n  background-color: #2d6737;\n  box-shadow: rgba(0, 0, 0, 0.26) 0px -4px 1px 0px inset, rgba(255, 255, 255, 0.17) 0px -1px 1px 0px, rgba(0, 0, 0, 0.15) 0px 3px 6px 2px;\n}\n\n.customCheckBoxInputSell:checked + .customCheckBoxWrapper .customCheckBox {\n  background-color: #7e0c0c;\n  color: white;\n  box-shadow: rgba(0, 0, 0, 0.23) 0px -4px 1px 0px inset, rgba(255, 255, 255, 0.17) 0px -1px 1px 0px, rgba(0, 0, 0, 0.17) 0px 2px 4px 1px;\n}\n\n.customCheckBoxInputSell:checked + .customCheckBoxWrapper .customCheckBox .inner {\n  transform: translateY(-2px);\n}\n\n.customCheckBoxInputSell + .customCheckBoxWrapper .customCheckBox:hover {\n  background-color: #7e0c0c;\n  box-shadow: rgba(0, 0, 0, 0.26) 0px -4px 1px 0px inset, rgba(255, 255, 255, 0.17) 0px -1px 1px 0px, rgba(0, 0, 0, 0.15) 0px 3px 6px 2px;\n}\n\n.customCheckBoxWrapper .customCheckBox:hover .inner {\n  transform: translateY(-2px);\n}\n\n\n/* SELECTOR */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
